// // GalleryAddEdit.jsx
// import React, { useEffect, useState } from 'react';
// import { Link, useParams, useNavigate } from 'react-router-dom';
// import { Button, Form, Spin, message, Row, Col } from 'antd';
// import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
// import axios from '../utils/axios';
// import BreadCrumb from '../components/Breadcrumb';
// import FilePreviewUploader from '../components/FilePreviewUploader';

// function GalleryAddEdit() {
// 	const navigate = useNavigate();
// 	const { editGalleryId } = useParams();
// 	const [isLoading, setIsLoading] = useState(false);
// 	const [fileList, setFileList] = useState([]);
// 	const [form] = Form.useForm();

// 	const get = () => {
// 		if (!editGalleryId) return;
// 		axios
// 			.get('/gallery', { params: { _id: editGalleryId } })
// 			.then((result) => {
// 				console.log(result.data);
// 				if (Array.isArray(result.data.data) && result.data.data.length) {
// 					const uploadedFileList = result.data.data[0]?.media?.map((media) => ({
// 						uid: media._id,
// 						name: media.mediaTitle,
// 						status: 'done',
// 						url: media.mediaPath,
// 					}));
// 					setFileList(uploadedFileList || []);
// 					form.setFieldsValue(result.data.data[0]);
// 				}
// 			})
// 			.finally(() => setIsLoading(false));
// 	};

// 	const onSave = () => {
// 		form.validateFields().then((values) => {
// 			setIsLoading(true);
// 			if (editGalleryId) values._id = editGalleryId;
// 			const media = [];
// 			fileList?.map(({ response }) => {
// 				if (response?.data?.length) {
// 					media.push(...response.data);
// 				}
// 				return response;
// 			});
// 			if (media.length) {
// 				values.media = media;
// 			}
// 			console.log('Uploaded Images:', values.media);

// 			axios({ method: editGalleryId ? 'put' : 'post', url: '/gallery', data: values })
// 				.then((result) => {
// 					if (result.data.success) {
// 						message.success(result.data.message);
// 						navigate('/gallery');
// 					} else {
// 						message.error(result.data.message);
// 						setIsLoading(false);
// 					}
// 				})
// 				.catch(() => {
// 					message.error('Oops! Something went wrong!');
// 					setIsLoading(false);
// 				});
// 		});
// 	};

// 	useEffect(() => {
// 		get();
// 	}, []);

// 	return (
// 		<Spin spinning={isLoading}>
// 			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { link: '/gallery', label: 'Gallery' }, { label: editGalleryId ? 'Edit' : 'Add' }]} />
// 			<div className='main-content'>
// 				<div className='page-header'>
// 					<div className='page-title'>{editGalleryId ? 'Edit Gallery' : 'Add Gallery'}</div>
// 					<div className='page-title-more'>
// 						<Link to='/gallery'>
// 							<Button icon={<ArrowLeftOutlined />}>Back</Button>
// 						</Link>
// 						<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
// 							Save
// 						</Button>
// 					</div>
// 				</div>
// 				<div className='form-content'>
// 					<Form form={form} layout='vertical' autoComplete='off'>
// 						<Row gutter={[16, 0]}>
// 							<Col sm={24} md={12}>
// 								<Form.Item label='Gallery Images' name='media'>
// 									<FilePreviewUploader Form={Form} maxItems={10} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
// 								</Form.Item>
// 							</Col>
// 						</Row>
// 					</Form>
// 				</div>
// 			</div>
// 		</Spin>
// 	);
// }
// export default GalleryAddEdit;

// // GalleryAddEdit.jsx (Updated)
// import React, { useEffect, useState } from 'react';
// import { Link, useParams, useNavigate } from 'react-router-dom';
// import { Button, Form, Spin, message, Row, Col, Select } from 'antd';
// import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
// import axios from '../utils/axios';
// import BreadCrumb from '../components/Breadcrumb';
// import FilePreviewUploader from '../components/FilePreviewUploader';

// const { Option } = Select;

// function GalleryAddEdit() {
// 	const navigate = useNavigate();
// 	const { editGalleryId } = useParams();
// 	const [isLoading, setIsLoading] = useState(false);
// 	const [fileList, setFileList] = useState([]);
// 	const [form] = Form.useForm();

// 	const get = () => {
// 		if (!editGalleryId) return;
// 		axios
// 			.get('/gallery', { params: { _id: editGalleryId } })
// 			.then((result) => {
// 				if (Array.isArray(result.data.data) && result.data.data.length) {
// 					const uploadedFileList = result.data.data[0]?.media?.map((media) => ({
// 						uid: media._id,
// 						name: media.mediaTitle,
// 						status: 'done',
// 						url: media.mediaPath,
// 					}));
// 					setFileList(uploadedFileList || []);
// 					form.setFieldsValue(result.data.data[0]);
// 				}
// 			})
// 			.finally(() => setIsLoading(false));
// 	};

// 	const onSave = () => {
// 		form.validateFields().then((values) => {
// 			setIsLoading(true);
// 			if (editGalleryId) values._id = editGalleryId;
// 			const media = [];
// 			fileList?.map(({ response }) => {
// 				if (response?.data?.length) {
// 					media.push(...response.data);
// 				}
// 				return response;
// 			});
// 			if (media.length) {
// 				values.media = media;
// 			}
// 			axios({ method: editGalleryId ? 'put' : 'post', url: '/gallery', data: values })
// 				.then((result) => {
// 					if (result.data.success) {
// 						message.success(result.data.message);
// 						navigate('/gallery');
// 					} else {
// 						message.error(result.data.message);
// 						setIsLoading(false);
// 					}
// 				})
// 				.catch(() => {
// 					message.error('Oops! Something went wrong!');
// 					setIsLoading(false);
// 				});
// 		});
// 	};

// 	useEffect(() => {
// 		get();
// 	}, []);

// 	return (
// 		<Spin spinning={isLoading}>
// 			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { link: '/gallery', label: 'Gallery' }, { label: editGalleryId ? 'Edit' : 'Add' }]} />
// 			<div className='main-content'>
// 				<div className='page-header'>
// 					<div className='page-title'>{editGalleryId ? 'Edit Gallery' : 'Add Gallery'}</div>
// 					<div className='page-title-more'>
// 						<Link to='/gallery'>
// 							<Button icon={<ArrowLeftOutlined />}>Back</Button>
// 						</Link>
// 						<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
// 							Save
// 						</Button>
// 					</div>
// 				</div>
// 				<div className='form-content'>
// 					<Form form={form} layout='vertical' autoComplete='off'>
// 						<Row gutter={[16, 0]}>
// 							<Col sm={24} md={12}>
// 								<Form.Item label='Gallery Images' name='media'>
// 									<FilePreviewUploader Form={Form} maxItems={10} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
// 								</Form.Item>
// 							</Col>
// 							<Col sm={24} md={12}>
// 								<Form.Item label='Category' name='category' rules={[{ required: true, message: 'Please select a category' }]}>
// 									<Select placeholder='Select Category'>
// 										<Option value='Trek'>Sahyadri Treks</Option>
// 										<Option value='Tour'>Domestic Tours</Option>
// 										<Option value='Tour'>Biker Special</Option>
// 										<Option value='Tour'>Devotional Tours</Option>
// 										<Option value='Tour'>Family And Kids Special</Option>
// 										<Option value='Tour'>Customize Your Travel Plan</Option>
// 										<Option value='Tour'>Himalaya Calling</Option>
// 										<Option value='All'>All</Option>
// 									</Select>
// 								</Form.Item>
// 							</Col>
// 						</Row>
// 					</Form>
// 				</div>
// 			</div>
// 		</Spin>
// 	);
// }
// export default GalleryAddEdit;

import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Row, Col, Select } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import FilePreviewUploader from '../components/FilePreviewUploader';

const { Option } = Select;

function GalleryAddEdit() {
	const navigate = useNavigate();
	const { editGalleryId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [form] = Form.useForm();

	const get = () => {
		if (!editGalleryId) return;
		axios
			.get('/gallery', { params: { _id: editGalleryId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const uploadedFileList = result.data.data[0]?.media?.map((media) => ({
						uid: media._id,
						name: media.mediaTitle,
						status: 'done',
						url: media.mediaPath,
					}));
					setFileList(uploadedFileList || []);
					form.setFieldsValue(result.data.data[0]);
				}
			})
			.finally(() => setIsLoading(false));
	};

	const onSave = () => {
		form.validateFields().then((values) => {
			setIsLoading(true);
			if (editGalleryId) values._id = editGalleryId;
			const media = [];
			fileList?.map(({ response }) => {
				if (response?.data?.length) {
					media.push(...response.data);
				}
				return response;
			});
			if (media.length) {
				values.media = media;
			}
			axios({ method: editGalleryId ? 'put' : 'post', url: '/gallery', data: values })
				.then((result) => {
					if (result.data.success) {
						message.success(result.data.message);
						navigate('/gallery');
					} else {
						message.error(result.data.message);
						setIsLoading(false);
					}
				})
				.catch(() => {
					message.error('Oops! Something went wrong!');
					setIsLoading(false);
				});
		});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<Spin spinning={isLoading}>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { link: '/gallery', label: 'Gallery' }, { label: editGalleryId ? 'Edit' : 'Add' }]} />
			<div className='main-content'>
				<div className='page-header'>
					<div className='page-title'>{editGalleryId ? 'Edit Gallery' : 'Add Gallery'}</div>
					<div className='page-title-more'>
						<Link to='/gallery'>
							<Button icon={<ArrowLeftOutlined />}>Back</Button>
						</Link>
						<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
							Save
						</Button>
					</div>
				</div>
				<div className='form-content'>
					<Form form={form} layout='vertical' autoComplete='off'>
						<Row gutter={[16, 0]}>
							<Col sm={24} md={12}>
								<Form.Item label='Gallery Images' name='media'>
									<FilePreviewUploader Form={Form} maxItems={10} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
								</Form.Item>
							</Col>
							<Col sm={24} md={12}>
								<Form.Item label='Category' name='category' rules={[{ required: true, message: 'Please select a category' }]}>
									<Select placeholder='Select Category'>
										<Option value='Sahyadri Treks'>Sahyadri Treks</Option>
										<Option value='Domestic Tours'>Domestic Tours</Option>
										<Option value='Biker Special'>Biker Special</Option>
										<Option value='Devotional Tours'>Devotional Tours</Option>
										<Option value='Family And Kids Special'>Family And Kids Special</Option>
										<Option value='Customize Your Travel Plan'>Customize Your Travel Plan</Option>
										<Option value='Himalaya Calling'>Himalaya Calling</Option>
										<Option value='All'>All</Option>
									</Select>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</div>
			</div>
		</Spin>
	);
}
export default GalleryAddEdit;
